import React, { useState } from 'react';

const paymentMethods = [
  { value: "gotowka", label: "Gotówka", icon: "💵", color: "var(--success)" },
  { value: "karta", label: "Karta", icon: "💳", color: "var(--info)" },
  { value: "blik", label: "BLIK", icon: "📱", color: "var(--orange)" },
  { value: "kupon", label: "Kupon", icon: "🎟️", color: "var(--purple)" },
  { value: "dzielona", label: "Dzielona", icon: "💰", color: "var(--orange)" },
];

// Modal pytający o kartę stałego klienta - wyświetlany na środku ekranu
const LoyaltyCardModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0,0,0,0.7)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 99999
    }}>
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'var(--card-bg)',
        borderRadius: '16px',
        padding: '2.5rem',
        maxWidth: '450px',
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
        border: '3px solid var(--info)'
      }}>
        <div style={{ fontSize: '64px', marginBottom: '1rem' }}>📱</div>
        <h2 style={{
          fontSize: '22px',
          fontWeight: '700',
          color: 'var(--info)',
          marginBottom: '1rem'
        }}>
          APLIKACJA SFD STACJONARNIE
        </h2>
        <p style={{
          fontSize: '16px',
          color: 'var(--text-secondary)',
          marginBottom: '2rem',
          lineHeight: '1.6'
        }}>
          Zapytaj klienta:<br/>
          <strong style={{ color: 'var(--text)', fontSize: '18px' }}>
            "Czy ma Pan/Pani zainstalowana aplikacje SFD STACJONARNIE?"
          </strong>
        </p>
        <button
          onClick={onClose}
          style={{
            padding: '1rem 4rem',
            fontSize: '16px',
            fontWeight: '700',
            backgroundColor: 'var(--info)',
            color: '#fff',
            border: 'none',
            borderRadius: '10px',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(59, 130, 246, 0.4)'
          }}
        >
          OK - Zapytalem
        </button>
      </div>
    </div>
  );
};

const PaymentSection = ({
  totalAmount,
  cart,
  loading,
  isPaymentProcessing,
  currentShift,
  canSell,
  canGiveDiscounts,
  paymentMethod,
  appPromptConfirmed,
  onPaymentMethodChange,
  onShowSplitPayment,
  onShowDiscountModal,
  onProcessPayment,
  onSaveDraft,
  onClearCart,
  onConfirmAppPrompt,
  skipWz,
  onToggleSkipWz
}) => {
  const [showLoyaltyModal, setShowLoyaltyModal] = useState(false);

  // Połącz loading i isPaymentProcessing dla blokady UI
  const isProcessing = loading || isPaymentProcessing;

  const handleDalejClick = () => {
    setShowLoyaltyModal(true);
  };

  const handleLoyaltyModalClose = () => {
    setShowLoyaltyModal(false);
    onConfirmAppPrompt(); // Potwierdza że można przejść do płatności
  };
  return (
    <div
      style={{
        backgroundColor: "var(--card-bg)",
        border: "1px solid var(--border)",
        borderRadius: "6px",
        padding: "0.75rem",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.4rem",
          marginBottom: "0.75rem",
          paddingBottom: "0.5rem",
          borderBottom: "1px solid var(--border)",
        }}
      >
        <span style={{ fontSize: "14px" }}>💳</span>
        <h3
          style={{
            margin: 0,
            fontSize: "12px",
            fontWeight: "600",
            color: "var(--text)",
          }}
        >
          Płatność
        </h3>
        <div
          style={{
            marginLeft: "auto",
            fontSize: "14px",
            fontWeight: "700",
            color: "var(--success)",
            padding: "0.2rem 0.5rem",
            backgroundColor: "var(--success-light)",
            borderRadius: "4px",
            border: "1px solid var(--success)",
          }}
        >
          {totalAmount.toFixed(2)} zł
        </div>
      </div>

      {/* Modal pytający o kartę stałego klienta */}
      <LoyaltyCardModal isOpen={showLoyaltyModal} onClose={handleLoyaltyModalClose} />

      {/* Przycisk Dalej - gdy koszyk nie jest pusty i nie potwierdzono */}
      {cart.length > 0 && !appPromptConfirmed ? (
        <div style={{ textAlign: "center", padding: "1rem 0" }}>
          <button
            onClick={handleDalejClick}
            style={{
              padding: "1rem 3rem",
              fontSize: "16px",
              fontWeight: "700",
              backgroundColor: "var(--success)",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
              width: "100%",
              boxShadow: "0 4px 12px rgba(34, 197, 94, 0.3)"
            }}
          >
            <span>Dalej</span>
            <span style={{ fontSize: "20px" }}>→</span>
          </button>
          <div style={{
            fontSize: "11px",
            color: "var(--text-muted)",
            marginTop: "0.5rem"
          }}>
            Do zaplaty: <strong style={{ color: "var(--success)" }}>{totalAmount.toFixed(2)} zl</strong>
          </div>
        </div>
      ) : (
        <>
          {/* Metody płatności - kompaktowe */}
          <div style={{ marginBottom: "0.75rem" }}>
            <div
              style={{
                fontSize: "10px",
                fontWeight: "600",
                color: "var(--text-muted)",
                marginBottom: "0.5rem",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
              }}
            >
              💰 Metoda płatności
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(5, 1fr)",
                gap: "0.4rem",
              }}
            >
              {paymentMethods.map((method) => (
                <button
                  key={method.value}
                  data-pos-btn="true"
                  disabled={isProcessing}
                  onClick={() => {
                    if (isProcessing) return;
                    if (method.value === 'dzielona') {
                      onShowSplitPayment();
                    } else {
                      onPaymentMethodChange(method.value);
                    }
                  }}
                  style={{
                    padding: "4px 10px",
                    fontSize: "11px",
                    border: paymentMethod === method.value ? `2px solid ${method.color}` : "1px solid var(--border)",
                    borderLeft: `3px solid ${method.color}`,
                    backgroundColor: paymentMethod === method.value ? method.color : "var(--card-bg)",
                    color: paymentMethod === method.value ? "#fff" : "var(--text-secondary)",
                    fontWeight: paymentMethod === method.value ? "700" : "normal",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0.2rem",
                    transition: "all 0.15s ease",
                    opacity: isProcessing ? 0.6 : 1,
                    cursor: isProcessing ? "not-allowed" : "pointer"
                  }}
                >
                  <span style={{ fontSize: "14px" }}>{method.icon}</span>
                  <span>{method.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* Toggle WZ - pominięcie wydania zewnętrznego */}
          <label
            data-pos-btn="true"
            style={{
              padding: "6px 12px",
              fontSize: "11px",
              border: skipWz ? "1px solid var(--warning)" : "1px solid var(--border)",
              backgroundColor: skipWz ? "var(--warning-light)" : "var(--card-bg)",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "0.5rem",
              marginBottom: "0.5rem",
            }}
          >
            <input
              type="checkbox"
              checked={skipWz}
              onChange={onToggleSkipWz}
              style={{ cursor: "pointer", margin: 0 }}
            />
            <span style={{ color: "var(--text)", fontWeight: skipWz ? "600" : "normal" }}>
              Pomin WZ
            </span>
            {skipWz && (
              <span style={{ fontSize: "10px", fontStyle: "italic", color: "var(--warning)" }}>
                (sprzedaz bez kontroli stanu)
              </span>
            )}
          </label>

          {/* Przyciski płatności - kompaktowe */}
          <div style={{ display: "flex", gap: "0.4rem" }}>
            {/* Przycisk rabatow - tylko dla uzytkownikow z uprawnieniem */}
            {canGiveDiscounts && (
              <button
                onClick={onShowDiscountModal}
                disabled={isProcessing}
                data-pos-btn="true"
                style={{
                  flex: 1,
                  padding: "4px 10px",
                  fontSize: "11px",
                  border: "1px solid var(--purple)",
                  backgroundColor: isProcessing ? "var(--border)" : "var(--purple-light)",
                  color: isProcessing ? "var(--text-muted)" : "var(--purple)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "0.1rem",
                  cursor: isProcessing ? "not-allowed" : "pointer",
                  opacity: isProcessing ? 0.6 : 1
                }}
              >
                <span style={{ fontSize: "12px" }}>🏷️</span>
                <span>Rabaty</span>
              </button>
            )}

            {/* Przycisk zapłaty - tylko dla użytkowników z uprawnieniem do sprzedaży */}
            <button
              onClick={() => onProcessPayment()}
              disabled={cart.length === 0 || isProcessing || !currentShift || !canSell}
              data-pos-btn="true"
              style={{
                flex: 3,
                padding: "6px 12px",
                fontSize: "12px",
                border: cart.length === 0 || !currentShift || !canSell ? "1px solid var(--border)" : "1px solid var(--success)",
                backgroundColor: isProcessing ? "var(--border)" : "var(--card-bg)",
                color: cart.length === 0 || !currentShift || !canSell || isProcessing ? "var(--text-muted)" : "var(--success)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.3rem",
                cursor: isProcessing ? "not-allowed" : "pointer",
                opacity: isProcessing ? 0.7 : 1
              }}
              title={!canSell ? "Brak uprawnien do sprzedazy" : isProcessing ? "Przetwarzanie platnosci..." : ""}
            >
              {isProcessing ? (
                <>⏳ Przetwarzanie...</>
              ) : !canSell ? (
                <>🔒 Brak uprawnien</>
              ) : (
                <>💳 Zaplac {totalAmount.toFixed(2)} zl</>
              )}
            </button>

            <button
              onClick={onSaveDraft}
              disabled={cart.length === 0 || isProcessing || !currentShift}
              data-pos-btn="true"
              style={{
                flex: 1,
                padding: "4px 10px",
                fontSize: "11px",
                border: "1px solid var(--text-muted)",
                backgroundColor:
                  cart.length === 0 || !currentShift || isProcessing ? "var(--border)" : "var(--bg)",
                color: "var(--text-muted)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "0.1rem",
                cursor: isProcessing ? "not-allowed" : "pointer",
                opacity: isProcessing ? 0.6 : 1
              }}
            >
              <span style={{ fontSize: "12px" }}>💾</span>
              <span>Szkic</span>
            </button>

            <button
              onClick={onClearCart}
              disabled={cart.length === 0 || isProcessing}
              data-pos-btn="true"
              style={{
                flex: 1,
                padding: "4px 10px",
                fontSize: "11px",
                border: "1px solid var(--danger)",
                backgroundColor: isProcessing ? "var(--border)" : "var(--danger-light)",
                color: isProcessing ? "var(--text-muted)" : "var(--danger)",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "0.1rem",
                cursor: isProcessing ? "not-allowed" : "pointer",
                opacity: isProcessing ? 0.6 : 1
              }}
            >
              <span style={{ fontSize: "12px" }}>🗑️</span>
              <span>Wyczysc</span>
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default React.memo(PaymentSection);
